import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropdownMenu } from '#pplx/frontend/aether/components/DropdownMenu/index.js';
import { useColorScheme } from '#pplx/frontend/aether/hooks/useColorScheme.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useCallback, useMemo } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
export const AccountMenuAppearanceSubmenu = ({ onColorSchemeChanged, } = {}) => {
    const { $t } = useIntl();
    const { colorScheme, isSystemColorScheme, setUserPreferredColorScheme } = useColorScheme();
    const isDarkMode = colorScheme === 'dark';
    const selectedTheme = isSystemColorScheme
        ? 'system'
        : colorScheme;
    const handleThemeChange = useCallback((value) => {
        if (value === 'system') {
            setUserPreferredColorScheme(undefined);
            onColorSchemeChanged?.(null);
        }
        else {
            setUserPreferredColorScheme(value);
            onColorSchemeChanged?.(value);
        }
    }, [onColorSchemeChanged, setUserPreferredColorScheme]);
    const selectedLabel = useMemo(() => {
        if (isSystemColorScheme) {
            return isDarkMode
                ? $t({
                    defaultMessage: 'System (Dark)',
                    description: 'Subtitle shown in the appearance submenu trigger when using system theme and current theme is dark',
                    id: '8ddec05af4',
                })
                : $t({
                    defaultMessage: 'System (Light)',
                    description: 'Subtitle shown in the appearance submenu trigger when using system theme and current theme is light',
                    id: 'bdaad5a11f',
                });
        }
        return isDarkMode
            ? $t({
                defaultMessage: 'Dark',
                description: 'Subtitle shown in the appearance submenu trigger when dark mode is active',
                id: 'd29b6710a0',
            })
            : $t({
                defaultMessage: 'Light',
                description: 'Subtitle shown in the appearance submenu trigger when light mode is active',
                id: 'b9867b2c4d',
            });
    }, [$t, isDarkMode, isSystemColorScheme]);
    return (_jsx(DropdownMenu.Submenu, { triggerElement: _jsx(DropdownMenu.SubmenuItem, { leadingAccessory: isDarkMode ? $icon('moon') : $icon('sun'), subtitle: selectedLabel, children: _jsx(FormattedMessage, { defaultMessage: "Appearance", description: "Label for the appearance submenu trigger in the sidebar account menu", id: "b296d5bf7f" }) }), children: _jsxs(DropdownMenu.RadioGroup, { value: selectedTheme, onValueChange: handleThemeChange, children: [_jsx(DropdownMenu.RadioItem, { value: "light", leadingAccessory: $icon('sun'), children: _jsx(FormattedMessage, { defaultMessage: "Light", description: "Option in the appearance submenu to use light mode", id: "d9fa057008" }) }), _jsx(DropdownMenu.RadioItem, { value: "dark", leadingAccessory: $icon('moon'), children: _jsx(FormattedMessage, { defaultMessage: "Dark", description: "Option in the appearance submenu to use dark mode", id: "6860b0912c" }) }), _jsx(DropdownMenu.RadioItem, { value: "system", leadingAccessory: $icon('device-imac'), children: _jsx(FormattedMessage, { defaultMessage: "System", description: "Option in the appearance submenu to follow system theme", id: "5adfa93db1" }) })] }) }));
};
//# sourceMappingURL=AccountMenuAppearanceSubmenu.js.map